/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddFirstTimeCouponRequest } from '../model';
// @ts-ignore
import { AddFirstTimeCouponResponse } from '../model';
/**
 * CouponsApiApiBillsBillCodeCouponsDelete - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponsApiApiBillsBillCodeCouponsDeleteAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeCouponsDelete', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/Coupons`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponsApiApiBillsCouponsFirstTimePost - axios parameter creator
 * 
 * @param {AddFirstTimeCouponRequest} [addFirstTimeCouponRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponsApiApiBillsCouponsFirstTimePostAxiosParamCreator (addFirstTimeCouponRequest?: AddFirstTimeCouponRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/Coupons/FirstTime`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addFirstTimeCouponRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiBillsBillCodeCouponsDelete operation in CouponsApi.
 * @export
 * @interface CouponsApiApiBillsBillCodeCouponsDeleteRequest
 */
export interface CouponsApiApiBillsBillCodeCouponsDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponsApiApiBillsBillCodeCouponsDelete
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsCouponsFirstTimePost operation in CouponsApi.
 * @export
 * @interface CouponsApiApiBillsCouponsFirstTimePostRequest
 */
export interface CouponsApiApiBillsCouponsFirstTimePostRequest {
    /**
     * 
     * @type {AddFirstTimeCouponRequest}
     * @memberof CouponsApiApiBillsCouponsFirstTimePost
     */
    readonly addFirstTimeCouponRequest?: AddFirstTimeCouponRequest
}

/**
* 
* @param {CouponsApiApiBillsBillCodeCouponsDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponsApiApiBillsBillCodeCouponsDelete(requestParameters: CouponsApiApiBillsBillCodeCouponsDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponsApiApiBillsBillCodeCouponsDeleteAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponsApiApiBillsCouponsFirstTimePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponsApiApiBillsCouponsFirstTimePost(requestParameters: CouponsApiApiBillsCouponsFirstTimePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponsApiApiBillsCouponsFirstTimePostAxiosParamCreator(requestParameters.addFirstTimeCouponRequest, options, configuration);
    const request: () => AxiosPromise<AddFirstTimeCouponResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
